import React from 'react'
import { Chart } from "react-google-charts";
function GisChart() {
    const data = [
        ["Task", "Hours per Day"],
        ["Landuse & Landcovers", 30],
        ["Property", 25],
        ["Transportation", 25],
        ["Utility", 20],
    ];
    const options = {
        title: "Most Accessed Dataset",
        titleTextStyle: {
            color:'#000',
            fontSize: 14,
            fontName: 'Poppins',
        },
        pieSliceBorderColor: 'transparent',
        pieStartAngle: 100, 
        sliceVisibilityThreshold: 0.02, 
        pieHole: 0.4,
        is3D: false,
        pieSliceText: 'none',
        legend: {
            position: 'none', 
        },
        colors: ["#FE6256", "#FFC300", "#A9FE55", "#73AF01"],
        chartArea: {
            width: '100%', 
            height: '60%',
            left: 5,       
            right: 5,      

        },

    };

    const renderCustomLegend = () => {
        return (
            <div className="custom-legend">
                {data.slice(1).map((item, index) => (
                    <div key={index} className="legend-item">
                        <div
                            style={{
                                width: '20px',
                                height: '13px',
                                backgroundColor: options.colors[index],
                                marginRight: '4px',
                                borderRadius: '8px',
                            }}
                        ></div>
                        <div style={{ color:'#000', fontSize: '10px' }}>{`${item[0]}`}</div>
                    </div>
                ))}
            </div>
        );
    };
    
    return (
        <>        
        <div style={{ backgroundColor: '#F5F5F5' , padding: '8px', borderRadius: '10px', overflow:"hidden",marginTop:"10px" }}>
            <Chart
                chartType="PieChart"
                width="100%"
                height="175px"
                data={data}
                options={{
                    ...options,
                    backgroundColor:'#F5F5F5', 
                }}
            />
            <div style={{ marginTop: '0px', color: 'white' }}>
                {renderCustomLegend()}
            </div>
        </div>
        <div style={{ backgroundColor:'#F5F5F5', padding: '8px', borderRadius: '10px', overflow:"hidden",marginTop:"12px" }}>
             <div className='d-flex justify-content-between'>
             <h6 className='usermonthtitle mb-0'>Recent Data Uploaded</h6>
             <button className='viewallbtn'>View all</button>
             </div>
             <div className="table-responsive">
              <table className="table table-dark-security caption-top userupload-table">
                <tbody>
                  <tr>
                    <td >
                      <div className='checkoxdiv justify-content-center'>
                        <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal">
                          <img src="img/fileuser.svg" alt='file' className='userdataimg'/>
                        </div>
                      </div>
                    </td>
                    <td>New dataset 'City Infrastructu...</td>
                    <td>02:00 PM</td>
                  </tr>
                  <tr>
                    <td >
                      <div className='checkoxdiv justify-content-center'>
                        <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal">
                          <img src="img/tarshbin-chart.svg" alt='remove' className='userdataimg'/>
                        </div>
                      </div>
                    </td>
                    <td>New dataset 'City Infrastructu...</td>
                    <td>02:00 PM</td>
                  </tr>
                  <tr>
                    <td >
                      <div className='checkoxdiv justify-content-center'>
                        <div type="button" data-bs-toggle="modal" data-bs-target="#editUserModal">
                          <img src="img/fileuser.svg" alt='file' className='userdataimg'/>
                        </div>
                      </div>
                    </td>
                    <td>New dataset 'City Infrastructu...</td>
                    <td>02:00 PM</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
        <div style={{ backgroundColor: '#F5F5F5', padding: '8px', borderRadius: '10px', overflow:"hidden",marginTop:"12px" }}>
             <h6 className='usermonthtitle mb-0'>Users this month</h6>
             <h3 className='usertotal'>2.4K</h3>
             <p className='usertext mb-0'>Total 2,400 users active at GIS platform
             in this month</p>
        </div>
        </>

    )
}

export default GisChart
